var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Cleave', {
    staticClass: "form-control",
    class: {
      'cleave-error': _vm.errors.length > 0,
      'text-right': _vm.type === 'currency' || _vm.type === 'numeral'
    },
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.$t(_vm.placeholder),
      "disabled": _vm.disabled,
      "raw": true,
      "options": _vm.options
    },
    on: {
      "input": _vm.updateData
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }